import React, { useEffect, useState } from 'react';
import '../../common/css/atrRequest.css';
import SaveModal from '../modal/saveModal';
import CustomDatePicker from '../common/datepicker';
import Cookies from 'js-cookie';
import axios from 'axios';
import { format } from 'date-fns';

function ATRRequest() {
    // 모달 상태
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    // ATR 발권 요청 데이터
    const [prePNR, setPrePNR] = useState('');
    const [preTL, setPreTL] = useState('');
    const [preTLtime, setPreTLtime] = useState('');
    const [preFB, setPreFB] = useState('');
    const [preBCC, setPreBCC] = useState('');
    const [preAuthNum, setPreAuthNum] = useState('');
    const [preItCode, setPreITCode] = useState('');
    const [preETC, setPreETC] = useState('');
    const [preChildInfo, setPreChildInfo] = useState('');
    const [preInfantInfo, setPreInfantInfo] = useState('');
    const [preFOC, setPreFOC] = useState('');
    const [preAdultSelling, setPreAdultSelling] = useState('0');
    const [preAdultNum, setPreAdultNum] = useState('0');
    const [preAdultTax, setPreAdultTax] = useState('0');
    const [preChildSelling, setPreChildSelling] = useState('0');
    const [preChildNum, setPreChildNum] = useState('0');
    const [preChildTax, setPreChildTax] = useState('0');
    const [preInfantSelling, setPreInfantSelling] = useState('0');
    const [preInfantNum, setPreInfantNum] = useState('0');
    const [preInfantTax, setPreInfantTax] = useState('0');
    const [preFOCSelling, setPreFOCSelling] = useState('0');
    const [preFOCTax, setPreFOCTax] = useState('0');
    const [preFOCNum, setPreFOCNum] = useState('0');
    const [preTotal, setPreTotal] = useState('0');
    const [preComm, setPreComm] = useState('0');
    const [preVAT, setPreVAT] = useState('0');
    const [preCardNum, setPreCardNum] = useState('');
    const [preCardHolder, setPreCardHolder] = useState('');
    const [preCardYear, setPreCardYear] = useState(0);
    const [preCardMonth, setPreCardMonth] = useState(0);
    const [preMonthlyment, setPreMonthlyment] = useState(0);
    const [depositContent, setDepositContent] = useState('');

    const [IsPaymentType, setIsPaymentType] = useState('cash');
    const [cardType, setCardType] = useState('BC');
    const [SaveBtn, setSaveBtn] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [regAgentId, setRegAgentId] = useState('');
    const [regAgentCode, setRegAgentCode] = useState('');
    const [regKornName, setRegKornName] = useState('');
    const [regAgentEmail, setRegAgentEmail] = useState('');
    const [isDeposit, setIsDeposit] = useState('false');

    // 달력
    const [selectedDate, setSelectedDate] = useState(new Date());

    // const agentPaymentType = (e) => {
    //     const value = e.target.value;
    //     if (value === 'cash') {
    //         setIsPaymentType('cash');
    //         setPreCardNum('');
    //         setPreCardHolder('');
    //         setPreCardYear(0);
    //         setPreCardMonth(0);
    //         setPreMonthlyment(0);
    //     } else {
    //         setIsPaymentType('card');
    //     }
    // };

    const handleDateChange = (date) => {
        const dateStr = format(date, 'yyyy-MM-dd HH:mm');
        setSelectedDate(date);
        setPreTL(dateStr.split(' ')[0]);
        setPreTLtime(dateStr.split(' ')[1]);
    };

    // 1인당 금액 성인, 소아, 유아 계산기
    useEffect(() => {
        const totalAmountCalculater = () => {
            const adultSelling = preAdultSelling === '' ? 0 : parseInt(preAdultSelling);
            const adultNum = preAdultNum === '' ? 0 : parseInt(preAdultNum);
            const adultTax = preAdultTax === '' ? 0 : parseInt(preAdultTax);
            const childSelling = preChildSelling === '' ? 0 : parseInt(preChildSelling);
            const childNum = preChildNum === '' ? 0 : parseInt(preChildNum);
            const childTax = preChildTax === '' ? 0 : parseInt(preChildTax);
            const infantSelling = preInfantSelling === '' ? 0 : parseInt(preInfantSelling);
            const infantNum = preInfantNum === '' ? 0 : parseInt(preInfantNum);
            const infantTax = preInfantTax === '' ? 0 : parseInt(preInfantTax);
            const FOCSelling = preFOCSelling === '' ? 0 : parseInt(preFOCSelling);
            const FOCTax = preFOCTax === '' ? 0 : parseInt(preFOCTax);
            const FOCNum = preFOCNum === '' ? 0 : parseInt(preFOCNum);

            const totalAmount =
                (adultSelling + adultTax) * adultNum +
                (childSelling + childTax) * childNum +
                (infantSelling + infantTax) * infantNum +
                (FOCSelling + FOCTax) * FOCNum;

            setPreTotal(totalAmount.toString());
        };

        totalAmountCalculater();
    }, [
        preAdultSelling,
        preAdultNum,
        preAdultTax,
        preChildSelling,
        preChildNum,
        preChildTax,
        preInfantSelling,
        preInfantNum,
        preInfantTax,
        preFOCSelling,
        preFOCNum,
        preFOCTax,
    ]);

    useEffect(() => {
        const axiosData = async () => {
            try {
                const date = new Date();
                const dateStr = format(date, 'yyyy-MM-dd HH:mm');
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }
                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/preticket/info`,
                    {
                        withCredentials: true,
                    },
                );
                setRegAgentName(response.data.userName);
                setRegKornName(response.data.kornName);
                setRegAgentId(response.data.userId);
                setRegAgentEmail(response.data.userEmail);
                setRegAgentPhone(response.data.userPhone);

                if (!preTL) setPreTL(dateStr.split(' ')[0]);
                if (!preTLtime) setPreTLtime(dateStr.split(' ')[1]);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);
            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const saveInfo = async () => {
        const audultPer = (preAdultSelling > 0 || preAdultTax > 0) && preAdultNum === '0';
        const childPer = (preChildSelling > 0 || preChildTax > 0) && preChildNum === '0';
        const infantPer = (preInfantSelling > 0 || preInfantTax > 0) && preInfantNum === '0';
        const focPer = (preFOCSelling > 0 || preFOCTax > 0) && preFOCNum === '0';

        if (prePNR === '') {
            setModalContent('항공사 예약번호를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (preTL === '' || preTLtime === '') {
            setModalContent('발권 TL을 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (preFB === '') {
            setModalContent('Fare Basis를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (preBCC === '') {
            setModalContent('BCC를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (preAuthNum === '') {
            setModalContent('Auth Number을 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (preTotal === '0') {
            setModalContent('TOTAL 입금액이 0원이므로 요청할 수 없습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (audultPer || childPer || infantPer || focPer) {
            setModalContent('인원수를 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else if (isDeposit === 'true' && depositContent === '') {
            setModalContent('데포짓 내용을 입력해주세요.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
            return;
        } else {
            try {
                const data = {
                    prePNR,
                    preTL,
                    preTLtime,
                    preFB,
                    preBCC,
                    preAuthNum,
                    preItCode,
                    preETC,
                    preChildInfo,
                    preInfantInfo,
                    preFOC,
                    preAdultSelling,
                    preAdultNum,
                    preAdultTax,
                    preChildSelling,
                    preChildNum,
                    preChildTax,
                    preInfantSelling,
                    preInfantNum,
                    preInfantTax,
                    preFOCSelling,
                    preFOCNum,
                    preFOCTax,
                    preTotal,
                    preComm,
                    preVAT,
                    prePayment: IsPaymentType,
                    preCard: IsPaymentType, //=== 'cash' ? '' : cardType
                    preCardNum,
                    preCardHolder,
                    preCardYear,
                    preCardMonth,
                    preMonthlyment,
                    preDOB: isDeposit,
                    preWith: depositContent,
                    regAgentName: regKornName,
                    regAgtPhone: regAgentPhone,
                    preEmail : regAgentEmail
                };

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }
                const result = await axios.post(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/preticket/request`,
                    data,
                    {
                        withCredentials: true,
                    },
                );

                if (result.data.result.rowsAffected[0] === 1) {
                    window.location.href = '/group/atrlist';
                }
            } catch (err) {
                setModalContent(err.response.data.message);
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);
            }
        }
    };

    return (
        <div className='bodyContainer'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>단체견적/발권</div>
                    <div>ATR 발권 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div id='contents'>
                <div className='signUpFromWrap'>
                    <div className='page_hgroup'>
                        <h2 className='title'>ATR 발권 요청</h2>
                    </div>

                    <div className='agentCheckWrap'>
                        <h4>ATR 발권 유의 사항</h4>

                        <table className='signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        ATR 발권 요청 문의
                                    </th>
                                    <td>
                                        <p className='table-padding wpal-atr-contact-info'>
                                            <span>전화: 02) 2085-8696</span>
                                            <span>|</span>
                                            <span>팩스: 02) 744-0544</span>
                                            <span>|</span>
                                            <span>세금계산서 E-mail: etax@philippineair.co.kr</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        접수 시간 및 수령 시간
                                    </th>
                                    <td>
                                        <div className='wpal-atr-innertable-padding'>
                                            <span className=' authNumberTxt'>
                                                ※ 발권 TL 당일의 발권 요청은 엄격히 금지됩니다.
                                            </span>
                                            <table className='wpal-atr-inner-table'>
                                                <thead>
                                                    <tr>
                                                        <th>사전 발권 신청 접수</th>
                                                        <th>전자세금계산서 접수</th>
                                                        <th>항공권 수령</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>09:00 ~ 12:00</td>
                                                        <td>당일 14:00 까지</td>
                                                        <td>익일 14:00 ~ 18:00</td>
                                                    </tr>
                                                </tbody>
                                                <tbody>
                                                    <tr>
                                                        <td>12:00 ~ 18:00</td>
                                                        <td>익일 09:00 ~ 12:00</td>
                                                        <td>익일 14:00 ~ 18:00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>구비서류</th>
                                    <td>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header'>
                                                [현금 결제 시]
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                1) 전자세금계산서, 2) 사전발권신청서, 3) 현금입금증
                                                (입금인을 명확히 기입한 경우 입금증 없어도 무방)
                                            </div>
                                        </div>
                                        {/* <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header'>
                                                [카드 결제 시]
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                1) 전자세금계산서, 2) 사전발권신청서, 3)
                                                UCCCF(앞/뒷면 압인, 카드 소지인 서명), 4) 카드
                                                앞/뒷면 CPY(카드 소지인의 자필서명),
                                                <br /> 5) 카드 소지인 신분증 COPY
                                            </div>
                                        </div>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-header table-line-b'>
                                                *법인카드 사용의 경우, 1) ~ 5) 서류 외에 하기 추가
                                                서류 필요
                                            </div>
                                            <div className='table-padding wpal-atr-td-content'>
                                                a) 무기명, 미싸인 - 수령인의 재직증명서 or 명함, b)
                                                기명 - 기명된 사람의 재직증명서 or 명함
                                            </div>
                                        </div>
                                        <div className='wpal-atr-td-padding'>
                                            <div className='table-padding wpal-atr-td-content'>
                                                ※ UCCCF로 카드 결제시에는 반드시 명단에 있는 승객의
                                                카드로만가능 / 제3자 카드로는 결제 불가능
                                            </div>
                                        </div> */}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 단체 정보 */}
                    <div className='agentCheckWrap'>
                        <h4>ATR 발권 요청</h4>

                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        ATR 발권 신청인
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='atrRequestor'
                                                value={regAgentName}
                                                disabled
                                            />
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        여행사명
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='atrRequestAgent'
                                                value={regKornName}
                                                disabled={regAgentId !== 'RAKSO'}
                                                onChange={(e) => setRegKornName(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        휴대폰번호
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='atrRequestorPhone'
                                                value={regAgentPhone}
                                                disabled={regAgentId !== 'RAKSO'}
                                                onChange={(e) => setRegAgentPhone(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        티켓수령 이메일
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='atrTicketEmail'
                                                value={regAgentEmail}
                                                disabled={regAgentId !== 'RAKSO'}
                                                onChange={(e) => setRegAgentEmail(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        항공사 예약번호
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='pnrNumber'
                                                value={prePNR}
                                                onChange={(e) =>
                                                    setPrePNR(
                                                        e.target.value.replace(
                                                            /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g,
                                                            '',
                                                        ),
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        발권 TL
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <CustomDatePicker
                                                selectedDate={selectedDate}
                                                onChange={handleDateChange}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        Fare Basis
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='fareBasis'
                                                value={preFB}
                                                onChange={(e) => setPreFB(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        BCC
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='bcc'
                                                value={preBCC}
                                                onChange={(e) =>
                                                    setPreBCC(
                                                        e.target.value.replace(
                                                            /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g,
                                                            '',
                                                        ),
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        Auth Number
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='authNum'
                                                value={preAuthNum}
                                                onChange={(e) =>
                                                    setPreAuthNum(
                                                        e.target.value.replace(
                                                            /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g,
                                                            '',
                                                        ),
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <th className='wpal-atr-td-header table-line-b'>IT Code</th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='idCode'
                                                value={preItCode}
                                                onChange={(e) => setPreITCode(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        요청 사항 / 비고
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <textarea
                                                className='wpal-tr-resize wpal-atr-textarea'
                                                value={preETC}
                                                onChange={(e) => setPreETC(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        어린이 승객 정보
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='childinfo'
                                                placeholder='이름/DOB/동반 성인 이름 또는 티켓번호'
                                                value={preChildInfo}
                                                onChange={(e) => setPreChildInfo(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        유아 승객 정보
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='infantinfo'
                                                placeholder='이름/DOB/동반 성인 이름 또는 티켓번호'
                                                value={preInfantInfo}
                                                onChange={(e) => setPreInfantInfo(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='wpal-atr-td-header table-line-b'>FOC</th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                id='foc'
                                                value={preFOC}
                                                onChange={(e) => setPreFOC(e.target.value)}
                                                placeholder='이름'
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th
                                        rowSpan={4}
                                        className='wpal-atr-each-price-wrap wpal-atr-td-header table-line-b'
                                    >
                                        1인당 금액
                                    </th>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                성인
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                <input
                                                    type='text'
                                                    id='adultprice'
                                                    value={parseInt(preAdultSelling).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreAdultSelling(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                <input
                                                    type='text'
                                                    id='adulttax'
                                                    value={parseInt(preAdultTax).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreAdultTax(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                <input
                                                    type='text'
                                                    id='adultcount'
                                                    value={preAdultNum}
                                                    onChange={(e) =>
                                                        setPreAdultNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                소아
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                <input
                                                    type='text'
                                                    id='childprice'
                                                    value={parseInt(preChildSelling).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreChildSelling(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                <input
                                                    type='text'
                                                    id='childtax'
                                                    value={parseInt(preChildTax).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreChildTax(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                <input
                                                    type='text'
                                                    id='childcount'
                                                    value={preChildNum}
                                                    onChange={(e) =>
                                                        setPreChildNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span className='wpal-atr-td-header table-line-b wpal-atr-each-price'>
                                                유아
                                            </span>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>판매가</span>
                                                <input
                                                    type='text'
                                                    id='infantprice'
                                                    value={parseInt(
                                                        preInfantSelling,
                                                    ).toLocaleString('ko-KR')}
                                                    onChange={(e) =>
                                                        setPreInfantSelling(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                <input
                                                    type='text'
                                                    id='infanttax'
                                                    value={parseInt(preInfantTax).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreInfantTax(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                <input
                                                    type='text'
                                                    id='infantcount'
                                                    value={preInfantNum}
                                                    onChange={(e) =>
                                                        setPreInfantNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-display-wrap'>
                                            <span
                                                className='wpal-atr-td-header table-line-b wpal-atr-each-price'
                                                style={{ margin: '0 65px 0 0' }}
                                            >
                                                FOC
                                            </span>
                                            <div className='wpal-atr-span-input-wrap '>
                                                <span className='wpal-atr-span'>판매가</span>
                                                <input
                                                    type='text'
                                                    id='adultprice'
                                                    value={parseInt(preFOCSelling).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreFOCSelling(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>TAX</span>
                                                <input
                                                    type='text'
                                                    id='adulttax'
                                                    value={parseInt(preFOCTax).toLocaleString(
                                                        'ko-KR',
                                                    )}
                                                    onChange={(e) =>
                                                        setPreFOCTax(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                                <span className='wpal-atr-span'>원</span>
                                            </div>
                                            <div className='wpal-atr-span-input-wrap'>
                                                <span className='wpal-atr-span'>인원</span>
                                                <input
                                                    type='text'
                                                    id='adultcount'
                                                    value={preFOCNum}
                                                    onChange={(e) =>
                                                        setPreFOCNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentCheckWrap'>
                        <table className='signUp-table wpal-atr-signUp-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th className='wpal-atr-td-header table-line-b'>
                                        <span className='important-value'>*</span>
                                        TOTAL 입금액
                                    </th>
                                    <td>
                                        <div className='table-padding wpal-atr-input-wrap wpal-display-wrap'>
                                            <input
                                                type='text'
                                                id='totalprice'
                                                value={parseInt(preTotal).toLocaleString('ko-KR')}
                                                disabled
                                            />
                                            <span className='wpal-atr-span'>원</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class='firstTable'>결제 수단</th>
                                    <td colSpan={3}>
                                        <div className=' wpal-atr-input-wrap'>
                                            <label class='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    value='cash'
                                                    name='paymentType'
                                                    // onClick={agentPaymentType}
                                                    defaultChecked
                                                />
                                                현금 입금
                                            </label>
                                            {/* <label class='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    value='card'
                                                    name='paymentType'
                                                    onClick={agentPaymentType}
                                                />
                                                신용카드 (승객 이외의 카드 불가)
                                            </label> */}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2} style={{ height: '110px' }}>
                                        DEPOSIT 여부
                                    </th>
                                    <td colSpan={3} style={{height:'50px'}}>
                                        <div className=' wpal-atr-input-wrap'>
                                            <label class='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    value='noDeposit'
                                                    name='isDeposit'
                                                    onClick={() => setIsDeposit('false')}
                                                    defaultChecked
                                                />
                                                없음
                                            </label>
                                            <label class='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    value='isDeposit'
                                                    name='isDeposit'
                                                    onClick={() => setIsDeposit('true')}
                                                />
                                                있음
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='table-padding wpal-atr-input-wrap'>
                                            <input
                                                type='text'
                                                placeholder='데포짓 금액과 입금일을 입력해주세요. 예) 1,900,000원 입금 (25/01/31)'
                                                {...(isDeposit === 'true'? {} : { disabled: true })}
                                                onChange={(e) => setDepositContent(e.target.value)}
                                                value={depositContent}
                                                maxLength={25}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                {IsPaymentType === 'card' ? (
                                    <>
                                        <tr>
                                            <th className='wpal-atr-td-header table-line-b'>
                                                카드사
                                            </th>
                                            <td colSpan={3}>
                                                <div className=' wpal-atr-input-wrap'>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='BC'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                            defaultChecked
                                                        />
                                                        비씨
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='HN'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        하나
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='SS'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        삼성
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='KB'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        국민
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='SH'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        신한
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='HD'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        현대
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='LE'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        롯데
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='AM'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        아멕스
                                                    </label>
                                                    <label class='tableRadio table-padding'>
                                                        <input
                                                            type='radio'
                                                            value='ETC'
                                                            name='cardType'
                                                            onClick={(e) =>
                                                                setCardType(e.target.value)
                                                            }
                                                        />
                                                        해외
                                                    </label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='wpal-atr-td-header table-line-b'>
                                                카드 번호
                                            </th>
                                            <td>
                                                <div className='table-padding wpal-atr-input-wrap'>
                                                    <input
                                                        type='text'
                                                        value={preCardNum}
                                                        onChange={(e) =>
                                                            setPreCardNum(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </td>
                                            <th className='wpal-atr-td-header table-line-b'>
                                                소유자명
                                            </th>
                                            <td>
                                                <div className='table-padding wpal-atr-input-wrap'>
                                                    <input
                                                        type='text'
                                                        value={preCardHolder}
                                                        onChange={(e) =>
                                                            setPreCardHolder(e.target.value)
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='wpal-atr-td-header table-line-b'>
                                                카드 유효기간
                                            </th>
                                            <td>
                                                <div className='table-padding wpal-display-wrap'>
                                                    <input
                                                        type='text'
                                                        className='wpal-atr-year'
                                                        value={preCardYear}
                                                        onChange={(e) =>
                                                            setPreCardYear(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                    <span className='wpal-atr-span'>년</span>
                                                    <input
                                                        type='text'
                                                        className='wpal-atr-month'
                                                        value={preCardMonth}
                                                        onChange={(e) =>
                                                            setPreCardMonth(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                    <span className='wpal-atr-span'>월</span>
                                                </div>
                                            </td>
                                            <th className='wpal-atr-td-header table-line-b'>
                                                할부
                                            </th>
                                            <td>
                                                <div className='table-padding wpal-atr-input-wrap'>
                                                    <input
                                                        type='text'
                                                        value={preMonthlyment}
                                                        onChange={(e) =>
                                                            setPreMonthlyment(
                                                                e.target.value.replace(
                                                                    /[^0-9]/g,
                                                                    '',
                                                                ),
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                ) : null}
                            </tbody>
                        </table>
                    </div>
                    <div className='submitArea'>
                        <input
                            type='button'
                            className='each-button btn46 blue'
                            value='ATR 발권 요청서 제출'
                            onClick={saveInfo}
                        ></input>
                    </div>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default ATRRequest;
